if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => {
        window.scroll({ top: 0, behavior: 'smooth' });

        // Move focus to the first interactive element in main content for better accessibility
        setTimeout(() => {
          const mainContent = document.getElementById('MainContent');
          if (mainContent) {
            const focusableElement = getFocusableElements(mainContent)[0];
            if (focusableElement) {
              focusableElement.focus();
            } else {
              // Fallback: focus the main content area itself
              mainContent.focus();
            }
          }
        }, 100); // Small delay to ensure scroll animation starts
      });
    }
  }

  window.BackToTop = BackToTop;

  customElements.define('back-to-top', BackToTop);
}
